// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html[lang=en-US] .about-product .second ._wid-50.right{padding-left:0}@media only screen and (min-width:1024px)and (max-width:1201px){html[lang=en-US] .about-product .second ._wid-50.right{padding-left:0}}@media only screen and (max-width:1024px){html[lang=en-US] .about-product .second ._wid-50.right{padding-left:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
